import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setTrack, setUnit, setUnitAct } from '../../../store/TrackSlice';
import { Anchor } from '../../_atoms/Anchor';
import { Item } from '../../_atoms/Item';
import { List } from '../../_atoms/List';

export const AudioList = (props) => {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();

  const itemRef = useRef({});
  useEffect(() => {
    itemRef.current[state.track.unit]?.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
  }, [state.track.unit]);

  const onAudioTrack = (type, idx) => {
    type === 'unit' ? dispatch(setUnitAct(idx)) : dispatch(setUnit(state.track.unit_act));
    type === 'track' && dispatch(setTrack(idx));
  };

  return (
    <List order={false} type={props.type} page={props.page}>
      {props.list.map((item, idx) => {
        return (
          <Item type={props.type} ref={(el) => {if (el) itemRef.current[idx] = el;}}>
            <Anchor 
              type={props.type}
              className={props.type === 'unit' ? (state.track.unit_act === idx && 'act') : ((state.track.unit === state.track.unit_act && state.track.track === idx) && 'act')}
              onClick={() => onAudioTrack(props.type, idx)}
              page={props.page}
            >
              {props.type === 'unit' ? (idx === props.list.length - 1 ? 'Readers' : 'Unit ') : 'Track ' + (item < 10 ? '0' + item : item)}{(props.type === 'unit' && idx !== props.list.length -1) ? (idx < 9 ? '0' + (idx + 1) : idx + 1) : ''}
            </Anchor>
          </Item>
        )
      })}

    </List>
  );
};

AudioList.propTypes = {
  type : PropTypes.string,
  order : PropTypes.bool,
  list : PropTypes.array
};

AudioList.defaultProps = {
  type : 'unit',
  order : false,
  list : ['Unit 01', 'Unit 02', 'Unit 03', 'Unit 04', 'Unit 05', 'Unit 06', 'Unit 07', 'Unit 08', 'Unit 09', 'Unit 10', 'Unit 11', 'Unit 12', 'Readers']
};

